import { jsx as _jsx } from "react/jsx-runtime";
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import PMSetupPage from './PMSetupPage/PMSetupPage';
export const ClientHubSetupPage = (param)=>{
    let { integration } = param;
    const { api, fetchClientHubItems } = useStoreActions();
    return /*#__PURE__*/ _jsx(PMSetupPage, {
        testId: "client-hub-setup",
        pmName: PracticeManagement.ClientHub,
        doDisconnect: api.clientHub.disconnect,
        getItems: fetchClientHubItems,
        linkServiceTemplate: api.clientHub.linkServiceTemplate,
        integration: integration,
        getServiceTemplateIntegratedIds: (template)=>template.integrations.clientHubIntegratedIds()
    });
};
